/* Home 2609 – FFB Chapter
   Same motion as the mock:
   - the bell on the latest release card rings twice when 60% of the card is on screen (CSS does the ringing), once
   - the moving polaroid plays only while it is on screen, never with sound; under reduced motion it is not shown (CSS) or played
   - on narrow screens the process board scrolls sideways: a fade on the right edge shows while there is more to see */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HAS_IO = 'IntersectionObserver' in window;

  function initBell(card) {
    if (!HAS_IO) return;
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          setTimeout(function () { card.classList.add('is-rung'); }, 250);
          obs.disconnect();
        }
      });
    }, { threshold: 0.6 });
    io.observe(card);
  }

  function initLive(video) {
    if (REDUCED.matches || !HAS_IO) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.35 });
    io.observe(video);
  }

  function initBoard(board) {
    var scroller = board.querySelector('.h2609-ffb-scroll');
    if (!scroller) return;
    function update() {
      var can = scroller.scrollWidth > scroller.clientWidth + 4;
      board.classList.toggle('is-scrollable', can);
      board.classList.toggle('is-end', scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4);
    }
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 600);
  }

  function init(root) {
    if (!root || root.h2609Ready) return;
    root.h2609Ready = true;
    var card = root.querySelector('[data-h2609-ffb-next]');
    if (card) initBell(card);
    var live = root.querySelector('[data-h2609-ffb-live]');
    if (live) initLive(live);
    var board = root.querySelector('[data-h2609-ffb-board]');
    if (board) initBoard(board);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-h2609-ffb]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
